import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { EditorState, RichUtils, Entity } from 'draft-js'

const LinkFieldSpan = (props) => (
  <span
    className="link-field"
    data-offset-key={props.offsetKey}>
    {props.children}
  </span>
)

const linkFieldStrategy = (contentBlock, callback) => {
  contentBlock.findEntityRanges(
    charMetaData => {
      const key = charMetaData.getEntity()
      return key && Entity.get(key)
    },
    callback
  )
}

export const linkFieldDecorators = [
  {
    strategy: linkFieldStrategy,
    component: LinkFieldSpan,
  }
]

export default class LinkField extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  handleMouseDown = event => {
    event.preventDefault()
    const { editorState } = this.props
    if (editorState.getSelection().isCollapsed()) {
      return
    }
    const url = prompt('Insert URL')
    if (!url) {
      return
    }
    const contentState = editorState.getCurrentContent()
    const contentStateWithEntity = contentState.createEntity('LINK', 'MUTABLE', { url })
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
    const newEditorState = EditorState.set(editorState, { currentContent: contentStateWithEntity })
    this.props.onChange(RichUtils.toggleLink(
      newEditorState,
      newEditorState.getSelection(),
      entityKey
    ))
  }

  render() {
    return (
      <div
        className="control"
        onMouseDown={this.handleMouseDown}>
        🔗
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/link_field.js